import { useState, useEffect, useRef, useCallback } from 'react';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material';
import { useSettings } from '../context';

const useCustomStyles = (styles: any, log?: boolean) => {
  const theme = useTheme();
  const {
    settings: { theme: selectedTheme },
  } = useSettings();
  const [classes, setClasses] = useState<any>(null);

  const generateClasses = () => {
    const evaluatedStyles =
      typeof styles === 'function' ? styles(theme) : styles;
    const generated: any = {};

    for (const key in evaluatedStyles) {
      generated[key] = css(evaluatedStyles[key]);
    }

    if (log) {
      console.log(generated);
    }
    setClasses(generated);
  };

  useEffect(() => {
    if (!classes) {
      generateClasses();
    }
  }, [styles, theme, classes]);

  useEffect(() => {
    generateClasses();
  }, [selectedTheme]);

  // Return the generated classes
  return classes || {};
};

export default useCustomStyles;
